import { render, staticRenderFns } from "./MyFavorite.vue?vue&type=template&id=01f8f588"
import script from "./MyFavorite.vue?vue&type=script&lang=js"
export * from "./MyFavorite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports